// import { theme } from "@chakra-ui/react";

export const sizes = {
  container: {
    "2xl": "120rem",
  },
};
